// extracted by mini-css-extract-plugin
export default {"specialist":"responsiveStyles_specialist__rkLpa","specialistInner":"responsiveStyles_specialistInner__IPngZ"};